import Script from "next/script";
import React from "react";
import { isOrg } from "../../utils/site";

// The WaniWani chat embed only runs on the Swedish site.
const WaniWaniEmbed = () =>
  isOrg("swe") ? (
    <Script
      id="waniwani-embed"
      strategy="afterInteractive"
      src="https://app.waniwani.ai/embed.js"
      data-api="https://app.waniwani.ai/api/mcp/chat"
      data-token="wwp_h5cdHcz7mY_JXnRvGp6Vz59W"
      data-channel-id="88d968aa-cd71-4c83-9a5d-dcd551f483f8"
      data-mode="off"
    />
  ) : null;

export default WaniWaniEmbed;
